// Corresponding to values in service-daemon/imodels/states.go
export const MEMBERREQUESTED=0;
export const MEMBERFLAGSREQUIRED=1;
export const MEMBERPENDING=2;
export const MEMBERREMOVE=3;
export const MEMBERCURRENT=4;
export const MEMBERDEPROVISIONED=5;

export const PROJECTREQUESTED=0;
export const PROJECTPENDING=1;
export const PROJECTDENIED=2;
export const PROJECTPROVISIONED=3;
export const PROJECTCLOSEREQUESTED=4;
export const PROJECTCLOSED=5;

// Constants also in imodels/constants.go
export const PVMFLAG="PI-Verified-Member"
export const RMFLAG="Member-Removed"

export const APIREADY="pong"
export const APIUNCONFIGURED="unconfigured"
export const APIMAINTENANCE="maintenance"

export const SCHEMAVERSION="1.1.0"

// Common error style
export const ERRORSTYLE = {color: "#800", fontWeight: "bold", marginLeft: "10px", fontSize: "16px"}
